import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavSupportedEnvironment } from '@retailer-platform/dashboard/routing'
import { webhookConfigurationRouter } from './routing/webhookConfigurationRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { webhookConfigurationAccessControl } from './access-control/webhookConfigurationAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'webhook-configuration',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'webhook-configuration-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    partnerScoped: [webhookConfigurationRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Set up webhook endpoints to automate external integrations such as inventory sync, order notifications, and fulfillment updates',
          labelId: 'webhookConfigurationDomain.title',
          route: 'webhook-configuration',
          accessControl: webhookConfigurationAccessControl,
          position: 1,
          positionNavV2: 1,
          // this is ignored when developing locally
          environment: NavSupportedEnvironment.Production,
          inToolPermissions: [
            {
              slug: Permission.DevPortalAdmin,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.DevPortalAdmin,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
